/* eslint-disable promise/param-names */
export const urlBaseApi = '' // Dejar vacío si es igual a la URL de la aplicación
export const setIdiomas = ['es', 'en', 'ca', 'fr', 'pt'] // El primero es el idioma por defecto

export const setDeImagenes = [480, 960, 1280]

// Re-exportaciones
export { default as chorrear } from './chorro-sw-cache'
// export { widgetUsuario } from '../widgets/usuario'
export { iniciarMenu } from './menu'
//
export function registrarServiceWorker () {
  return new Promise((resuelve, rechaza) => {
    return rechaza(new Error('No se está usando service worker'))
    /*
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(swReg => {
          return resuelve(swReg)
        })
        .catch(error => {
          return rechaza(error)
        })
    } else {
      return rechaza(new Error('El navegador no soporta service worker'))
    }
    */
  })
}

export function obtenerIdiomaUrl () {
  const partes = document.location.pathname.split('/')
  partes.shift() // Quita el host
  return setIdiomas.includes(partes[0]) ? partes[0] : setIdiomas[0]
}

export function setIdiomaPagina () {
  const idioma = obtenerIdiomaUrl()
  // Setea html lang
  document.documentElement.lang = idioma
  /*
  // Setea href y hreflang
  let hrefOrig
  const enlaces = document.querySelectorAll('[href]')
  const idiomaUrl = idioma === setIdiomas[0] ? '' : idioma + '/'
  enlaces.forEach(enlace => {
    hrefOrig = enlace.href
    enlace.href = enlace.href.replace(/\[\[idiomaUrl\]\]/, idiomaUrl)
    if (hrefOrig !== enlace.href) { // Si cambió href
      enlace.hreflang = idioma // set hreflang
    }
  })
  */
}

export function obtenerSrcset (srcImg) {
  const srcSinExt = srcImg.substr(0, srcImg.length - 4)
  const extArchivo = srcImg.substr(-3)
  let srcset = ''
  setDeImagenes.forEach(ancho => {
    srcset += `${srcSinExt}-${ancho}.${extArchivo} ${ancho}w, `
  })
  return srcset.substr(0, srcset.length - 2) // Retorna sin último espacio y coma
}

export function esperaAjax (mostrar, proceso) {
  let capaEspera = document.getElementById('capaEspera')
  if (mostrar) {
    if (!capaEspera) {
      capaEspera = document.createElement('div')
      capaEspera.id = 'capaEspera'
      // let spinner = document.createElement('img');
      // spinner.src = '/interfaz/img/spinner.svg';
      // spinner.classList.add('spinner');
      // capaEspera.appendChild( spinner );
      document.body.appendChild(capaEspera)
    }
    //
    const jsonProcesos = capaEspera.getAttribute('data-procesos')
    const aProcesos = jsonProcesos ? JSON.parse(jsonProcesos) : []
    if (aProcesos.indexOf(proceso) === -1) {
      aProcesos.push(proceso)
      capaEspera.dataset.procesos = JSON.stringify(aProcesos)
    }
    //
    capaEspera.classList.add('visible')
  } else {
    capaEspera = document.getElementById('capaEspera')
    if (capaEspera) {
      //
      const jsonProcesos = capaEspera.getAttribute('data-procesos')
      const aProcesos = jsonProcesos ? JSON.parse(jsonProcesos) : []
      const indice = aProcesos.indexOf(proceso)
      if (indice > -1) {
        aProcesos.splice(indice, 1)
        capaEspera.dataset.procesos = JSON.stringify(aProcesos)
      }
      //
      if (aProcesos.length === 0) {
        capaEspera.classList.remove('visible')
      }
    }
  }
};
